import { BotMessage, UserMessage } from 'src/types';
import { editMessage, retrieveLastBotMessage } from 'src/utils/messages';
import { MessageActions } from '../actions/message';

type Message = BotMessage | UserMessage;

const initialState: Message[] = [];

const messagesReducer = (state = initialState, action: MessageActions): Message[] => {
	switch (action.type) {
		case 'message/add':
			return [...state, action.payload];
		case 'message/remove-all':
			return [];
		case 'message/edit':
			return editMessage(state, action.payload.originalMessage);

		case 'message/add-chunk': {
			const lastMessage = retrieveLastBotMessage(state);
			lastMessage.error = action.payload.error;
			lastMessage.text = (lastMessage.text || '') + action.payload.text;
			return [...state.slice(0, -1), lastMessage];
		}
		case 'message/add-outdated': {
			const lastMessage = retrieveLastBotMessage(state);
			lastMessage.outdated = action.payload;
			return [...state.slice(0, -1), lastMessage];
		}
		case 'message/add-complete-chunk': {
			const lastMessage = retrieveLastBotMessage(state);
			const { questionId, sources, internetSources, text, error } = action.payload;
			lastMessage.completed = true;
			lastMessage.id = questionId;
			lastMessage.sources = sources;
			lastMessage.internetSources = internetSources;
			lastMessage.text = text;
			if (error !== undefined) lastMessage.error = error;
			return [...state.slice(0, -1), lastMessage];
		}
		default:
			return state;
	}
};

export default messagesReducer;
